import { Avatar, Button, List, Popover } from "antd"
import localStorageManagement from "../../../../helper/services/localStorageServices";
import { KeyOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";

const AccountInformation: React.FC<{ isVisible: boolean }> = (props) => {
    const user = localStorageManagement.getUser();
    const popoverContent = (
        <List>
            <List.Item>
                <Button icon={<KeyOutlined />} disabled={true}>Đổi mật khẩu</Button>
            </List.Item>
            <List.Item>
                <Button
                    icon={<LogoutOutlined />}
                    danger
                    onClick={() => {
                        localStorageManagement.removeUser();
                        window.location.reload();
                    }}
                >
                    Đăng xuất
                </Button>
            </List.Item>
        </List>
    )
    return props.isVisible ?
        (<Popover
            placement="bottomLeft"
            title={user?.username}
            content={popoverContent}
        >
            <Avatar icon={<UserOutlined />} />
        </Popover>)
        : <></>
}
export default AccountInformation;